var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M18.39 47.317L0 29.737l5.499-5.708 12.118 11.585L43.797 3 50 7.94z"}})}
var staticRenderFns = []

export { render, staticRenderFns }